import View from './View';
import schema from './schema';
import icon from '@plone/volto/icons/hero.svg';

const HeroBlock = {
  id: 'heroes',
  title: 'Hero',
  view: View,
  icon: icon,
  group: 'castle',
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockSchema: schema,
};

export default HeroBlock;
